var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBestieicon = function SvgBestieicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.043 43.043"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#228185",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.043,
    d: "M16.719.522C15.162 8.816 8.706 15.359.522 16.936M43.522 16.936C35.337 15.359 28.88 8.816 27.324.522M27.324 42.522c1.557-8.295 7.955-14.838 16.198-16.415M.522 26.165c8.184 1.52 14.64 8.062 16.197 16.357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#228185",
    d: "M38.507 21.259c-8.185-1.578-14.641-8.12-16.197-16.415a.29.29 0 0 0-.577 0C20.177 13.14 13.78 19.681 5.536 21.26a.294.294 0 0 0 0 .584c8.243 1.519 14.641 8.061 16.197 16.356a.29.29 0 0 0 .577 0c1.556-8.295 8.012-14.837 16.197-16.356.288-.059.288-.526 0-.584m-23.69.292a7.2 7.2 0 0 1-2.767-.35h.173c4.668-1.403 8.127-5.433 9.453-9.64v-.174a7 7 0 0 1 .46 2.511c-.114 3.564-3.458 7.419-7.32 7.653"
  }))));
};
export default SvgBestieicon;